import { ArticlesGrid } from "../components/ArticlesGrid";
import { useSeo } from "../lib/useSeo";

export const ArticlesIndex = () => {
    useSeo({
        title: "Blog — Hydration Articles",
        description:
            "Research-backed articles on water intake, hydration, electrolytes, dehydration symptoms, and athletic performance. Updated weekly.",
        path: "/blog",
    });

    return (
        <>
            <section className="border-b border-foreground py-12 sm:py-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
                    <div className="editorial-label mb-3">The library</div>
                    <h1 className="text-5xl sm:text-7xl font-black tracking-tighter uppercase leading-none mb-4">
                        Blog.
                    </h1>
                    <p className="text-lg text-foreground/70 max-w-2xl">
                        Research-backed essays on hydration, electrolytes, athletic
                        performance, and the myths the supplement industry doesn't want you
                        to know.
                    </p>
                </div>
            </section>
            <ArticlesGrid heading="Latest field notes." />
        </>
    );
};
